export const dummyDocList = [
  {
    id: '1',
    documentid: 'T12345-123',
    all_custodians: 'John Doe',
    email_subject: 'Email subject',
    filename: 'MyFileNew.pdf',
    file_type: 'pdf',
    family_date: '2025/02/10',
    family_relationship: 'Parent',
    from: 'James',
    custid: '1231',
    canHaveSummary: 'Yes',
    summaryText:
      'This is the test summary text is a long string checking the flow of the string in the component, again today is the holiday for some people. This is random text for summary test checking for big string and big text. ',
    nlpSummary: false,
  },
  {
    id: '2',
    documentid: 'H3423-3535',
    all_custodians: 'Brad Smith',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.mp4',
    file_type: 'mp4',
    family_date: '2025/02/10',
    family_relationship: 'Child',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'No',
    nlpSummary: false,
  },
  {
    id: '3',
    documentid: 'P4646-3535',
    all_custodians: 'Rahul Sharma',
    email_subject: 'test subject email',
    filename: 'MyFileNew.ppt',
    file_type: 'ppt',
    family_date: '2025/02/10',
    family_relationship: 'Standalone',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    nlpSummary: true,
  },
  {
    id: '4',
    documentid: 'P4646-3535',
    all_custodians: 'Dev Patel',
    email_subject: 'subject email random',
    filename: 'MyFileNew.jpeg',
    file_type: 'jpeg',
    family_date: '2025/02/10',
    family_relationship: 'Parent/Child',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    nlpSummary: false,
  },
  {
    id: '5',
    documentid: 'T12345-123',
    all_custodians: 'John Doe',
    email_subject: '',
    filename: 'MyFileNew.email',
    file_type: 'email',
    family_date: '2025/02/10',
    family_relationship: 'Parent',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    summaryText: 'This is the test summary text',
    nlpSummary: false,
  },
  {
    id: '6',
    documentid: 'H3423-3535',
    all_custodians: 'John Best',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.mp4',
    file_type: 'mp4',
    family_date: '2025/02/10',
    family_relationship: 'Child',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'No',
    nlpSummary: false,
  },
  {
    id: '7',
    documentid: 'P4646-3535',
    all_custodians: 'Sachin Patel',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.ppt',
    file_type: 'ppt',
    family_date: '2025/02/10',
    family_relationship: 'Standalone',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    nlpSummary: true,
  },
  {
    id: '8',
    documentid: 'P4646-3535',
    all_custodians: 'Rohit Sharma',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.jpeg',
    file_type: 'jpeg',
    family_date: '2025/02/10',
    family_relationship: 'Parent/Child',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    nlpSummary: false,
  },
  {
    id: '9',
    documentid: 'T12345-123',
    all_custodians: 'Suresh Raina',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.pdf',
    file_type: 'pdf',
    family_date: '2025/02/10',
    family_relationship: 'Parent',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    summaryText: 'This is the test summary text',
    nlpSummary: false,
  },
  {
    id: '10',
    documentid: 'H3423-3535',
    all_custodians: 'Random Name',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.mp4',
    file_type: 'mp4',
    family_date: '2025/02/10',
    family_relationship: 'Child',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'No',
    nlpSummary: false,
  },
  {
    id: '11',
    documentid: 'P4646-3535',
    all_custodians: 'Jennifer Haddin',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.ppt',
    file_type: 'ppt',
    family_date: '2025/02/10',
    family_relationship: 'Standalone',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    nlpSummary: true,
  },
  {
    id: '12',
    documentid: 'P4646-3535',
    all_custodians: 'Alex Carey',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.jpeg',
    file_type: 'jpeg',
    family_date: '2025/02/10',
    family_relationship: 'Parent/Child',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    nlpSummary: false,
  },
  {
    id: '13',
    documentid: 'T12345-123',
    all_custodians: 'James Little',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.pdf',
    file_type: 'pdf',
    family_date: '2025/02/10',
    family_relationship: 'Parent',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    summaryText: 'This is the test summary text',
    nlpSummary: false,
  },
  {
    id: '14',
    documentid: 'H3423-3535',
    all_custodians: 'Stuart David',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.mp4',
    file_type: 'mp4',
    family_date: '2025/02/10',
    family_relationship: 'Child',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'No',
    nlpSummary: false,
  },
  {
    id: '15',
    documentid: 'P4646-3535',
    all_custodians: 'James Anderson',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.ppt',
    file_type: 'ppt',
    family_date: '2025/02/10',
    family_relationship: 'Standalone',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    nlpSummary: true,
  },
  {
    id: '16',
    documentid: 'P4646-3535',
    all_custodians: 'Sergio Ramos',
    email_subject: 'Email subject test',
    filename: 'MyFileNew.jpeg',
    file_type: 'contact',
    family_date: '2025/02/10',
    family_relationship: 'Parent/Child',
    from: 'James',
    custid: '1232',
    canHaveSummary: 'Yes',
    nlpSummary: false,
  },
];

export const NullfieldOption = {label: 'Choose', id: '0'};

export const sortOptions = [
  {label: 'ASC', id: '1'},
  {label: 'DESC', id: '2'},
];
